import { DadosCadastrais } from '../atoms/forms/DadosCadastrais'
import { DadosPonto } from '../atoms/forms/DadosPonto'
import DescontoDSR from '../atoms/forms/DescontoDSR'
import OutrosDados from '../atoms/forms/OutrosDados'

export const tabs = [
    {
        name: 'empresa',
        label: 'Cadastro',
        content: <DadosCadastrais />,
    },
    {
        name: 'ponto',
        label: 'Ponto',
        content: <DadosPonto />,
    },
    {
        name: 'dsr',
        label: 'Desconto de DSR',
        content: <DescontoDSR />,
    },
    {
        name: 'outros',
        label: 'Outros',
        content: <OutrosDados />,
    },
]
